module.exports = {
  defaultTitle: "medienkram by Stefan Helker",
  brand: "medienkram by Stefan Helker",
  url: "https://medienkram.de",
  legalName: "Stefan Helker",
  analyticsDomain: "medienkram.de",
  social: {
    linkedin: "https://www.linkedin.com/in/stefanhelker",
    xing: "https://www.xing.com/profile/Stefan_Helker",
  },
  address: {
    street: "Schloßallee 18",
    city: "Bedburg",
    region: "Nordrhein-Westfalen",
    country: "DE",
    zipCode: "50181",
  },
  contact: {
    email: "anfrage@medienkram.de",
    phone: "+4915678567932",
    phoneDisplay: "+49 156 78567932",
  },
  foundingDate: "2018",
  // Bedburg, Schloßallee (approximate)
  geo: { latitude: 50.988, longitude: 6.573 },
}
